module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-masker-box"
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "vux-masker",
    class: {
      'vux-masker-fullscreen': _vm.fullscreen
    },
    style: (_vm.style)
  }, [_vm._t("content")], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ec2b47b"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/masker/index.vue
// module id = 202
// module chunks = 1